module.exports = __webpack_public_path__ + "static/media/C2_low_short_44.1k.9d4cbcaa.mp3";